import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as navigationActions from "../../actions/navigationActions";
import * as partialUpdatesActions from "../../actions/partialUpdatesActions";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.GET_PREPARED_PARTIAL_UPDATES_COUNT_AFTER_INIT:
            if (response.data === 0) {
                return [];
            }

            return [partialUpdatesActions.getNewPartialUpdates()];
        case handlers.GET_PREPARED_PARTIAL_UPDATES_COUNT:
            return [
                {
                    type: actionTypes.PARTIAL_UPDATES_SAVE_COUNT,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.GET_ALL_PREPARED_UPDATES_PER_DATABASE:
            return [
                {
                    type: actionTypes.PARTIAL_UPDATES_SAVE_DATA,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.APPLY_ALL_PREPARED_UPDATES_PER_DATABASE:
            return [
                navigationActions.closeModal(componentTypes.PARTIAL_UPDATE_MODAL),
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: false
                    }
                },
                {
                    type: actionTypes.PARTIAL_UPDATES_CLEAN_ALL
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_DATABASES_LIST
                    },
                    method: handlers.GET_DATABASES_LIST,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_ACTIVE_DATABASE
                    },
                    method: handlers.GET_ACTIVE_DATABASE,
                    tabId: 0
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
